import React from "react";
import { RuleTableBuilder } from "../RuleTableBuilder";
import { getEmptyRuleTable, getRuleTableWithData, getRuleTableWithMultipleEmptyRows } from "../Testing/TestDataSetup";
import { DataDefinition } from "../../../../rule-engine-core/Common/Data/DataDefinition";
import { StoryNode } from "../../../../CommonUI/StoryBook/StoryData";
import { getTestInputDataDefinition } from "../../../../CommonUI/Example/DataDefinition";

export const RuleTableStories = [
    new StoryNode(
        () => {
            let ruleDefinition = getEmptyRuleTable();
            let outdef = new DataDefinition();
            ruleDefinition.executionResult = outdef;
            let indef = new DataDefinition();
            ruleDefinition.inputData = indef;

            return <RuleTableBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Rule Table",
        "Empty",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getRuleTableWithMultipleEmptyRows();
            let outdef = new DataDefinition();
            ruleDefinition.executionResult = outdef;
            let indef = new DataDefinition();
            ruleDefinition.inputData = indef;

            return <RuleTableBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Rule Table",
        "Multiple Empty Rows",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getRuleTableWithData();
            let outdef = new DataDefinition();
            ruleDefinition.executionResult = outdef;

            return <RuleTableBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Rule Table",
        "With Data",
    ),
    new StoryNode(
        () => {
            let dataDef = getTestInputDataDefinition();
            let ruleDefinition = getRuleTableWithData();

            ruleDefinition.executionResult = () => {
                return dataDef;
            };
            ruleDefinition.inputData = new DataDefinition();

            return <RuleTableBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Rule Table",
        "Read Only Output",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getRuleTableWithData();
            let dataDef = getTestInputDataDefinition();
            ruleDefinition.inputData = () => {
                return dataDef;
            };
            ruleDefinition.executionResult = new DataDefinition();

            return <RuleTableBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Rule Table",
        "Read Only Input",
    ),
];
